import { select, take, takeEvery, put, call, fork } from 'redux-saga/effects'
import { userSelector } from 'auth/selectors'
import { refreshAuthenticatedUser } from 'auth/actions'
import { indicateProgress } from '../api'
import { apiLanguageCodeSelector } from '../i18n/selectors'
import { initPayment } from '../credit-cards/actions'
import { LOCATION_CHANGE } from '../browser-location'
import { selectedCreditCardSelector } from '../booking/selectors'
import { getReservationConfirmation } from '../confirmation/actions'
import { GET_RESERVATION_CONFIRMATION_RESPONSE } from '../confirmation/constants'

import * as constants from './constants'
import * as actions from './actions'
import * as selectors from './selectors'
import * as api from './api'

function* promoCodeSaga() {
    yield takeEvery(constants.REDEEM_PROMO_CODE, function*({ item, rawPromoCode }) {
        const apiLanguageCode = yield select(apiLanguageCodeSelector)
        const { token } = yield select(userSelector)
        try {
            const result = yield call(
                indicateProgress,
                `redeemPromoCode${item.id}`,
                api.redeemPromoCode,
                item,
                rawPromoCode,
                apiLanguageCode,
                token
            )
            yield put(actions.redeemedPromoCode(item, rawPromoCode, result))
        } catch (exception) {}
    })
}

function* purchaseSaga() {
    while (true) {
        const { singleItem, recaptchaToken } = yield take(constants.MAKE_PURCHASE)
        const card = yield select(selectedCreditCardSelector)

        try {
            yield call(indicateProgress, { names: ['makePurchase'], clearPending: true }, function*() {
                const { token, details } = yield select(userSelector)
                let items
                let paymentTotal
                let locationId
                let boletoData

                if (singleItem) {
                    items = [singleItem]
                    paymentTotal = items[0].promoCode ? items[0].promoCode.discountTotal : items[0].rate.amount
                    locationId = items[0].rate.eDataLocationId
                    boletoData = singleItem.boletoData
                } else {
                    const basket = yield select(selectors.basketSelector)
                    paymentTotal = yield select(selectors.totalSelector)
                    locationId = yield select(selectors.locationIdSelector)
                    items = basket.items
                }

                const { orderId, reservationId } = yield call(
                    api.createReservation,
                    token,
                    items,
                    details,
                    yield select(apiLanguageCodeSelector),
                    window.PAYMENT_SERVICE_PROVIDER === 'INGENICO' ? undefined : card,
                    boletoData,
                    recaptchaToken
                )
                yield put(initPayment(card, paymentTotal, locationId, orderId))

                const { type, error } = yield take([
                    constants.PAYMENT_SUCCESS,
                    constants.PAYMENT_CANCELLED,
                    constants.PAYMENT_ERROR,
                ])

                yield put(getReservationConfirmation(reservationId))

                if (type === constants.PAYMENT_SUCCESS) {
                    const basket = yield select(selectors.basketSelector)
                    yield take(GET_RESERVATION_CONFIRMATION_RESPONSE)
                    yield put(refreshAuthenticatedUser())
                    yield put(actions.purchaseCompleted(basket, paymentTotal))
                    yield take(LOCATION_CHANGE)
                    yield put(actions.clearBasket())
                } else if (type === constants.PAYMENT_ERROR) throw new Error(error)
            })
        } catch (exception) {
            yield put(actions.purchaseError())
        }
    }
}

export default function* rootSaga() {
    yield fork(promoCodeSaga)
    yield fork(purchaseSaga)
}
